import { Component, Input } from '@angular/core';
import { CommonModule, NgClass } from '@angular/common';
import { RouterOutlet } from '@angular/router';
import { ExtendedModule } from '@angular/flex-layout/extended';

@Component({
    selector: 'app-body',
    templateUrl: './body.component.html',
    styleUrl: './body.component.scss',
    standalone: true,
    imports: [NgClass, ExtendedModule, RouterOutlet]
})
export class BodyComponent {

  @Input() collapsed = false;
  @Input() screenWidth = 0;

  getBodyClass(): string {
    let styleClass = '';
    if(this.collapsed && this.screenWidth > 768) {
      styleClass = 'body-trimmed'
    } else if(this.collapsed && this.screenWidth <= 768 && this.screenWidth > 0) {
      styleClass = 'body-md-screen'
    }
    return styleClass;
  }
}
